import { t } from '@lingui/macro';

import type { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';
import { PriceTransparencyLevels } from '@rover/types/src/PriceTransparencyLevel';

export const GET_PRICE_TRANSPARENCY_CONDENSED_BANNER_TEXT = (
  priceTransparencyLevel: PriceTransparencyLevel | undefined,
  bookingFeePercentage: string | undefined
): string | undefined => {
  if (!priceTransparencyLevel) {
    return undefined;
  }
  if (priceTransparencyLevel === PriceTransparencyLevels.full_condensed) {
    return t`Prices include <0>all fees</0>.`;
  }
  if (priceTransparencyLevel === PriceTransparencyLevels.lite_condensed && bookingFeePercentage) {
    return t`Prices may vary based on your selections. A <0>booking fee</0> of ${bookingFeePercentage} will apply.`;
  }
  return undefined;
};
